import { useState } from 'react';

import { BaseButton, ConfirmationModal } from 'wbs-components-lib';

import { Box, Typography } from '@mui/material';

import {
  useResetDailyRewardVisitsMutation,
  useResetCompletedDailyTasksMutation,
  useResetReceivedRewardsMutation,
  useResetSpecialDropDatesMutation,
} from '@services';

import { ResetTypesEnum } from './constants';

import styles from './DailyBonusesResetControls.module.css';

const { resetControls, resetControlsContainer } = styles;

export const DailyBonusesResetControls = () => {
  const [currentResetType, setCurrentResetType] = useState<ResetTypesEnum | null>(null);
  const [isResetModalOpened, setIsResetModalOpened] = useState<boolean>(false);

  const [resetDailyRewardVisits, { isLoading: isVisitsResetting }] = useResetDailyRewardVisitsMutation();
  const [resetReceivedRewards, { isLoading: isRewardsResetting }] = useResetReceivedRewardsMutation();
  const [resetCompletedDailyTasks, { isLoading: isDailyTasksResetting }] = useResetCompletedDailyTasksMutation();
  const [resetSpecialDropDates, { isLoading: isSpecialDropDatesResetting }] = useResetSpecialDropDatesMutation();

  const handleResetDailyRewardVisits = async () => {
    await resetDailyRewardVisits();
  };

  const handleResetReceivedRewards = async () => {
    await resetReceivedRewards();
  };

  const handleResetCompletedDailyTasks = async () => {
    await resetCompletedDailyTasks();
  };

  const handleResetSpecialDropDates = async () => {
    await resetSpecialDropDates();
  };

  const handleResetModalOpen = (resetType: ResetTypesEnum) => {
    setCurrentResetType(resetType);

    setIsResetModalOpened(true);
  };

  const handleResetModalClose = () => {
    setCurrentResetType(null);

    setIsResetModalOpened(false);
  };

  const handleReset = async () => {
    let currentResetCallback = () => {};

    switch (currentResetType) {
      case ResetTypesEnum.REWARDS: {
        currentResetCallback = handleResetReceivedRewards;

        break;
      }
      case ResetTypesEnum.DAILY_TASKS: {
        currentResetCallback = handleResetCompletedDailyTasks;

        break;
      }
      case ResetTypesEnum.DAILY_VISITS: {
        currentResetCallback = handleResetDailyRewardVisits;

        break;
      }
      case ResetTypesEnum.SPECIAL_DROP: {
        currentResetCallback = handleResetSpecialDropDates;

        break;
      }
      default: {
        break;
      }
    }

    await currentResetCallback();

    handleResetModalClose();
  };

  const isResetting = isVisitsResetting || isRewardsResetting || isDailyTasksResetting || isSpecialDropDatesResetting;

  return (
    <>
      <Box className={resetControlsContainer}>
        <Typography fontSize="18px" fontWeight="600">
          Reset controls:
        </Typography>
        <Box className={resetControls}>
          <BaseButton onClick={() => handleResetModalOpen(ResetTypesEnum.REWARDS)}>Reset Rewards</BaseButton>
          <BaseButton onClick={() => handleResetModalOpen(ResetTypesEnum.DAILY_TASKS)}>Reset Daily Tasks</BaseButton>
          <BaseButton onClick={() => handleResetModalOpen(ResetTypesEnum.DAILY_VISITS)}>Reset Daily Visits</BaseButton>
          <BaseButton onClick={() => handleResetModalOpen(ResetTypesEnum.SPECIAL_DROP)}>Reset Special Drop</BaseButton>
        </Box>
      </Box>
      <ConfirmationModal
        buttonConfirmedText="Reset"
        headerTitle={`Reset ${currentResetType}`}
        onSubmit={handleReset}
        isOpened={isResetModalOpened}
        isLoading={isResetting}
        handleClose={handleResetModalClose}
      >
        Are you sure that you want to reset {currentResetType}?
      </ConfirmationModal>
    </>
  );
};
